// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "#33ace1";
var _3 = "#3361e1";
var _4 = "#00a474";
var _5 = "#332a4b";
var _6 = "#95c653";
var _7 = "#f66733";
var _8 = "#f57a7a";
var _9 = "#6d6db5";
var _a = "#e02d4f";
var _b = "#fecf0c";
var _c = "#ff892e";
var _d = "rgba(255,137,46,.16)";
var _e = "#a4a7b7";
var _f = "#cf0838";
var _10 = "rgba(207,8,56,.1)";
var _11 = "rgba(207,8,56,.16)";
var _12 = "rgba(207,8,56,.2)";
var _13 = "rgba(207,8,56,.5)";
var _14 = "rgba(207,8,56,.75)";
var _15 = "rgba(207,8,56,.85)";
var _16 = "#1570ef";
var _17 = "#757575";
var _18 = "#eaecf0";
var _19 = "#d0d5dd";
var _1a = "#98a2b3";
var _1b = "#f9fafb";
var _1c = "#667085";
var _1d = "#344054";
var _1e = "#101828";
var _1f = "#f6f6f6";
var _20 = "#7f56d9";
var _21 = "#8a8fa3";
var _22 = "#f5f4f5";
var _23 = "#e3e7f4";
var _24 = "#959aad";
var _25 = "rgba(149,154,173,.16)";
var _26 = "rgba(149,154,173,.5)";
var _27 = "#e0e0e0";
var _28 = "#95a3ad";
var _29 = "#383838";
var _2a = "#f66733";
var _2b = "rgba(246,103,51,.16)";
var _2c = "rgba(246,103,51,.32)";
var _2d = "rgba(246,103,51,.5)";
var _2e = "rgba(246,103,51,.75)";
var _2f = "#333f48";
var _30 = "rgba(51,63,72,.16)";
var _31 = "rgba(51,63,72,.4)";
var _32 = "rgba(51,63,72,.5)";
var _33 = "rgba(51,63,72,.6)";
var _34 = "#fecf0c";
var _35 = "#333f48";
var _36 = "#3361e1";
var _37 = "rgba(51,97,225,.16)";
var _38 = "#e02d4f";
var _39 = "#4085de";
var _3a = "rgba(64,133,222,.16)";
var _3b = "#1997a3";
var _3c = "#333f48";
var _3d = "#23ccc3";
var _3e = "#fcc7b3";
var _3f = "#222732";
var _40 = "rgba(34,39,50,.25)";
var _41 = "rgba(34,39,50,.5)";
var _42 = "rgba(34,39,50,.75)";
var _43 = "#333f48";
var _44 = "#fff";
var _45 = "#00a474";
var _46 = "rgba(0,164,116,.08)";
var _47 = "rgba(0,164,116,.16)";
var _48 = "rgba(0,164,116,.75)";
var _49 = "#95c653";
var _4a = "#23ccc3";
var _4b = "#ffc107";
var _4c = "rgba(255,193,7,.5)";
var _4d = "#fff";
var _4e = "#e1e1e9";
var _4f = "#fecf0c";
var _50 = "rgba(254,207,12,.16)";
var _51 = "rgba(254,207,12,.25)";
var _52 = "rgba(254,207,12,.75)";
export { _1 as "black", _2 as "boxBlue", _3 as "boxDarkBlue", _4 as "boxDarkGreen", _5 as "boxDarkPurple", _6 as "boxGreen", _7 as "boxOrange", _8 as "boxPink", _9 as "boxPurple", _a as "boxRed", _b as "boxYellow", _c as "carrot", _d as "carrot16", _e as "darkGray", _f as "error", _10 as "error10", _11 as "error16", _12 as "error20", _13 as "error50", _14 as "error75", _15 as "error85", _16 as "graphBlue", _17 as "gray", _18 as "gray200", _19 as "gray300", _1a as "gray400", _1b as "gray50", _1c as "gray500", _1d as "gray700", _1e as "gray900", _1f as "lightGray", _20 as "lightOrchid", _21 as "lightSlateGray", _22 as "lightSmoke", _23 as "lighterGray", _24 as "manatee", _25 as "manatee16", _26 as "manatee50", _27 as "mediumGray", _28 as "navigationText", _29 as "obsidian", _2a as "orange", _2b as "orange16", _2c as "orange32", _2d as "orange50", _2e as "orange75", _2f as "primary", _30 as "primary16", _31 as "primary40", _32 as "primary50", _33 as "primary60", _34 as "primaryButtonBackground", _35 as "primaryButtonText", _36 as "rainboots", _37 as "rainboots16", _38 as "red", _39 as "royalBlue", _3a as "royalBlue16", _3b as "scheduleInterrupt", _3c as "scheduleLoop", _3d as "scheduleMessageBlock", _3e as "scheduleMusic", _3f as "secondary", _40 as "secondary25", _41 as "secondary50", _42 as "secondary75", _43 as "secondaryButtonBackground", _44 as "secondaryButtonText", _45 as "success", _46 as "success10", _47 as "success16", _48 as "success75", _49 as "sushi", _4a as "teal", _4b as "warning", _4c as "warning50", _4d as "white", _4e as "whiteSmoke", _4f as "yellow", _50 as "yellow16", _51 as "yellow25", _52 as "yellow75" }
